import React from "react";
import Multiselect from "multiselect-react-dropdown";
import SchoolAdminDashboard from "../component/schoolAdminPortal/schoolAdminDashboard";
import { CircularProgress, FormGroup, Toolbar } from "@material-ui/core";
import { Link } from "react-router-dom";
import backarrow from "../assets/images/back-arrow.png";
import Container from "@material-ui/core/Container";
import { formatContactNumber } from "../utils";
import { Field } from "formik";
import blankProfile from "../component/schoolAdminPortal/images/blank-profile.png";
import CustomDropDown from "./FormFields/CustomDropDown";
import PageNotFoundPage from "./PageNotFoundPage";
import { openConfirmationPopup } from "../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import FormikTextField from "./FormFields/FormikInputField";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";
import { ContentLayoutSpinner } from "../component/spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "./ContentLayoutHeader";
import ImageUploadContainer from "./FormFields/ImageUploadContainer";

const EditUserProfile = ({
  userRole,
  imagePreviewUrl,
  handleLogoUpload,
  id,
  groupsData,
  selectedValues,
  onSelectOrRemoveGroups,
  permissions,
  URL,
  formik,
  myref,
  specialityList,
  graduationYearText,
  setGraduationYearText,
  getYearList,
  cancelType,
  loading,
  speciality,
  setSpeciality,
}) => {
  const dispatch = useDispatch();
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const handleCancel = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        type: cancelType,
        cancelLink: URL,
      },
    });
  };
  return (
    <div
      // className="content-layout add-sectionn p-0 position-relative"
      className={
        isDrawerOpen
          ? "content-layout add-sectionn p-0 position-relative"
          : "toggle-content-layout add-sectionn p-0 position-relative"
      }
    >
      <SchoolAdminDashboard />
      {userRole === "TEAM_ADMIN" ||
      userRole === "ATHLETE" ||
      userRole === "COACH" ? (
        <>
          <ContentLayoutSpinner animate={loading?.pageLoading} />
          <ContentLayoutHeader
            heading="Edit Profile"
            handleCancel={handleCancel}
            navigationLink={URL}
            btnText={"Update"}
            loading={loading?.buttonLoading}
            disabled={!formik.isValid}
          />
          <Container className="mg-top-70">
            <form name="adminRegistrationForm" className="moboMargin-5">
              <div className="row">
                <div className="col-12 col-lg-5 col-md-10">
                  <h6 className="team-title bold fs-18  ">
                    Personal Information
                  </h6>
                  <div className="white-card2 ">
                    <ImageUploadContainer
                      id="upload-photo-1"
                      logoUrl={imagePreviewUrl}
                      handleUpload={handleLogoUpload}
                      label={
                        imagePreviewUrl
                          ? "Update Profile Photo"
                          : "Add Profile Photo"
                      }
                      loading={loading?.profileImageLoading}
                    />
                  </div>
                  <div className="clear20"></div>
                  <div className="white-card2 ">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <FormikTextField
                          label="First Name"
                          formik={formik}
                          fieldName="firstName"
                          placeholder="Enter First name"
                          labelFontSize="fs-18"
                        />
                        <FormikTextField
                          label="Last Name"
                          formik={formik}
                          fieldName="lastName"
                          placeholder="Enter Last name"
                          labelFontSize="fs-18"
                        />
                        <FormikTextField
                          label="Email"
                          formik={formik}
                          fieldName="email"
                          placeholder="Enter Email Address"
                          labelFontSize="fs-18"
                          isDisabled={true}
                        />
                        <FormGroup>
                          <label className="fmlabel mt-6 semi-bold fs-18">
                            Phone Number <span className="redstar">*</span>
                          </label>
                          <Field
                            type="phone"
                            maxLength="10"
                            className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel  ${
                              formik.errors.phoneNumber && "is-invalid"
                            } `}
                            name="phoneNumber"
                            placeholder="Enter Phone Number"
                            onKeyUp={(e) =>
                              formatContactNumber(e.target.value, myref)
                            }
                          />
                          <div className="errorMsg fs-14 medium">
                            {formik.errors.phoneNumber}
                          </div>
                        </FormGroup>
                        {userRole === "ATHLETE" && (
                          <>
                            <FormGroup className="mg-top-20 mg-bottom-20">
                              <label className="fmlabel mt-6 semi-bold fs-18">
                                Graduation Year{" "}
                                <span className="redstar">*</span>
                              </label>
                              <CustomDropDown
                                selected={graduationYearText}
                                setSelected={setGraduationYearText}
                                formik={formik}
                                fieldName="graduationYear"
                                defaultSelectOption="Select Graduation Year"
                                options={getYearList()}
                                fieldToShow="label"
                                optionValue="label"
                              />
                            </FormGroup>
                            <FormikTextField
                              label="Position Played"
                              formik={formik}
                              fieldName="positionPlayed"
                              placeholder="Enter Position Played"
                              labelFontSize="fs-18"
                            />
                            <FormikTextField
                              label="Jersey Number"
                              formik={formik}
                              fieldName="jerseyNumber"
                              placeholder="Enter Jersey Number"
                              labelFontSize="fs-18"
                            />
                          </>
                        )}
                        {userRole !== "ATHLETE" && (
                          <FormGroup className="mg-top-20 mg-bottom-20">
                            <label className="fmlabel mt-6 semi-bold fs-18">
                              Speciality <span className="redstar">*</span>
                            </label>
                            <CustomDropDown
                              selected={speciality}
                              setSelected={setSpeciality}
                              formik={formik}
                              fieldName="speciality"
                              defaultSelectOption="Select Speciality"
                              options={specialityList}
                              fieldToShow="specialtyName"
                              optionValue="specialtyName"
                            />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <label className="fmlabel mt-6 semi-bold fs-18">
                            Groups <span className="redstar"></span>
                          </label>
                          <Multiselect
                            emptyRecordMsg="No Data Available"
                            options={groupsData}
                            selectedValues={selectedValues}
                            onSelect={onSelectOrRemoveGroups}
                            onRemove={onSelectOrRemoveGroups}
                            displayValue="name"
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  <div className="clear20"></div>
                </div>
                <div className="col-12 col-md-10 col-lg-6 ">
                  {userRole !== "ATHLETE" && (
                    <div className="">
                      <h6 className="team-title bold fs-18   title-margin">
                        {(userRole === "COACH" && "Assigned Coach Rights") ||
                          (userRole === "TEAM_ADMIN" &&
                            "Assigned Team Admin Rights")}
                      </h6>
                      {permissions.length !== 0 && (
                        <div className="athlete-bg p-4">
                          {permissions.map((data) => (
                            <div
                              key={data.id}
                              div
                              className="admin-role text-secondary font-rajdhani"
                            >
                              <Checkbox
                                icon={
                                  <BsCircle fontSize="20px" color="#13005A" />
                                }
                                checkedIcon={
                                  <BsFillCheckCircleFill
                                    fontSize="20px"
                                    color="#13005A"
                                  />
                                }
                                name={data.displayName}
                                checked={data.checked}
                                className="rights-check-icon opacity05"
                                disabled
                              />
                              <h6 className="mx-2 ">{data.displayName}</h6>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {userRole === "ATHLETE" && (
                    <div>
                      <h6 className="team-title bold fs-18 title-margin ">
                        Social Media
                      </h6>
                      <div className="athlete-bg">
                        <div className="activity-trending-container mg-left-auto pd-15 brd-none">
                          <FormikTextField
                            label="Instagram"
                            formik={formik}
                            fieldName="instaUrl"
                            placeholder="Enter Instagram Account Link"
                            labelFontSize="fs-18"
                            notRequired={true}
                          />
                          <FormikTextField
                            label="Twitter"
                            formik={formik}
                            fieldName="twitterUrl"
                            placeholder="Enter Twitter Account Link"
                            labelFontSize="fs-18"
                            notRequired={true}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </Container>
        </>
      ) : (
        <PageNotFoundPage />
      )}
    </div>
  );
};

export default EditUserProfile;
